import { useSearchSourcingCandidatesTotalCountQuery } from 'generated-graphql/hooks/apollo-hooks';
import {
  SearchableSourcedCandidateFilterInput,
  SourcedCandidateStatus
} from 'generated-graphql/types';

type UseAnalyseDetailsTabTotalsProps = {
  organizationId: string;
  candidateBatchId: string;
};

export const useAnalyseDetailsTabTotals = ({
  organizationId,
  candidateBatchId
}: UseAnalyseDetailsTabTotalsProps) => {
  const sourcedCandidateFilter: SearchableSourcedCandidateFilterInput = {
    organizationId: { eq: organizationId },
    candidateBatchId: { eq: candidateBatchId },
    status: { ne: SourcedCandidateStatus.AwaitingEnrichment }
  };

  const { data: sourcedCandidateData, loading: sourcedCandidateLoading } =
    useSearchSourcingCandidatesTotalCountQuery({
      variables: {
        filter: sourcedCandidateFilter
      },
      skip: !organizationId || !candidateBatchId
    });

  return {
    sourcedCandidatesTotal:
      sourcedCandidateData?.searchSourcedCandidates?.total ?? 0,
    loading: sourcedCandidateLoading
  };
};
